module.exports = __webpack_public_path__ + "static/ilustracion-landing-01-a9fd8b0047c9e1de074516f8435fb938.svg";